var $        = require('jquery');
var lib_core = require("lib-core");

var AbstractUIView = function (model, stateMachine) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;

    // OBSERVERS
    self.model.position.onChange('dragEl', function(){
        self.setPosition();
    },1);

    lib_core.GuiEvents.addEvents({
        UI_DRAG_MOUSE_DOWN: {id: 'ui_01', name: "UI_DRAG_MOUSE_DOWN" }
    });

};

AbstractUIView.prototype.setPosition = function() {
    this.getTemplate().setPos(this.model.position().x, this.model.position().y);
};

AbstractUIView.prototype.attachDraggingListeners = function(editorView) {

    var self = this;

    this.getTemplate().addMoveCursor();

    this.getTemplate().$el.on('Cioui:Draggable:MouseDown', function(e, event){

        var mouseCoord = editorView.relativeMouseCoord(event);

        var cEvent = new lib_core.GuiEvent()
            .type(lib_core.GuiEvents.UI_DRAG_MOUSE_DOWN)
            .data('mouseCoord', mouseCoord)
            .element('uiSelectionModel', self.model);

        return self.stateMachine.handle(cEvent);
    });

};

module.exports = AbstractUIView;
